import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ApplicationStore } from '@core/stores/application.store';
import { TranslatePipe } from '@ngx-translate/core';
import { ComponentCardComponent } from '@shared/components/common/component-card/component-card.component';

@Component({
  selector: 'app-user-address-card',
  imports: [
    FormsModule,
    TranslatePipe,
    ComponentCardComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './user-account-card.component.html'
})
export class UserAccountCardComponent {
  readonly applicationStore = inject(ApplicationStore);

}
